import React, { useState, useEffect } from 'react'
import './CookieConsent.css'

const STORAGE_KEY = 'cookie_consent'

export default function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'granted') {
      updateConsent('granted')
    } else if (!saved) {
      setVisible(true)
    }
    // 'denied' -> ramane denied (default-ul), nu mai aratam banner-ul
  }, [])

  function updateConsent(state) {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: state,
        ad_storage: state,
        ad_user_data: state,
        ad_personalization: state,
      })
    }
  }

  function accept() {
    localStorage.setItem(STORAGE_KEY, 'granted')
    updateConsent('granted')
    setVisible(false)
  }

  function reject() {
    localStorage.setItem(STORAGE_KEY, 'denied')
    updateConsent('denied')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="cookie-consent" role="dialog" aria-label="Consimtamant cookie-uri">
      <div className="cookie-consent-text">
        <strong>Folosim cookie-uri</strong>
        <p>Folosim cookie-uri pentru a analiza traficul si a imbunatati experienta (Google Analytics). Poti accepta sau refuza oricand.</p>
      </div>
      <div className="cookie-consent-actions">
        <button className="cookie-btn cookie-btn-reject" onClick={reject}>Refuz</button>
        <button className="cookie-btn cookie-btn-accept" onClick={accept}>Accept</button>
      </div>
    </div>
  )
}
